var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.2,
    d: "M9.546 1.583c-.33-1.014-1.763-1.014-2.092 0L6.156 5.578H1.955c-1.066 0-1.509 1.364-.647 1.99l3.399 2.47-1.298 3.994c-.33 1.014.83 1.857 1.692 1.23L8.5 12.793l3.399 2.47c.862.626 2.022-.217 1.692-1.23l-1.298-3.996 3.399-2.469c.862-.626.419-1.99-.647-1.99h-4.2L9.545 1.583Zm2.725 8.385Zm-.037.112Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvgStar);
export default __webpack_public_path__ + "static/media/SvgStar.c04cb4d4.svg";
export { ForwardRef as ReactComponent };